<wsb-template class="page-height-fix" page='createEmail' (templateSelected)="onTemplateSelected($event)" ></wsb-template>
